// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent;
  --overflow: hidden;
}

.w-h-100 {
  width: 100%;
  height: 100vh;
}

.box-container {
  position: absolute;
  top: 10px;
  left: 1px;
  height: 100vh;
  width: 100%;
}

.eu-council-game-container {
  position: absolute;
  top: 0;
  z-index: 1;
}

.container {
  position: absolute;
  top: 0;
}

.custom-container {
  position: relative;
  top: 0;
  height: 100%;
  z-index: -2;
}

.modal-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 51, 153, 0.6901960784);
  z-index: 14;
}

.reveal {
  position: absolute;
  bottom: 4rem;
  right: 1rem;
  background: #f5db6c;
  background-image: linear-gradient(0deg, rgba(var(--ion-color-avatar-choose-contrast-rgb), 0) 0%, rgba(var(--ion-color-avatar-choose-contrast-rgb), 0.48) 100%);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 1rem;
  min-width: 10rem;
  height: 2rem;
  border: 0.083rem solid var(--color-primary-blue);
  z-index: 10;
}

.text {
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  text-align: center;
  line-height: 1rem;
  padding-inline: 0.5rem;
}

.text-dismiss {
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  text-align: center;
  line-height: 1rem;
}

.text2 {
  margin-top: 0.5rem;
  padding-left: 3rem;
  padding-right: 3rem;
  font-size: 0.833rem;
  color: var(--color-primary-blue);
  text-align: center;
  line-height: 1.333rem;
}

.box2 {
  position: relative;
  width: 25rem;
  margin: 2.083rem auto;
  padding: 0.833rem;
  text-align: center;
  border-radius: 0.458rem;
  background: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
}

.btn-group {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.topic-box {
  top: 6rem;
}

.text-title {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  text-align: center;
  font-size: 1.167rem;
}

.btn-group .button1 {
  background-color: var(--color-primary-blue);
  border: none;
  color: white;
  padding: 0.7rem 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
}

.btn-group .button2 {
  border: 0.118rem solid var(--color-primary-blue);
  border-radius: 1.33rem;
  color: var(--color-primary-blue);
  text-align: center;
  padding: 0.6rem 1.5rem;
  margin-left: 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
}

.button {
  border: 0.083rem solid var(--color-primary-blue);
  border-radius: 1rem;
  font-size: 0.667rem;
  height: 2.1rem;
  width: 8rem;
  color: var(--color-primary-blue);
  text-align: center;
  background: #f5db6c;
  margin-top: 0.5rem;
  margin-left: 1.5rem;
}

.button-end {
  border-end-end-radius: 3rem;
  border-start-end-radius: 3rem;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}

.bg-container {
  height: 100vh;
  position: relative;
  background-color: var(--color-primary-blue);
  z-index: -1;
}
.bg-container .bg-lantern {
  display: flex;
  background: url('lantern-bg-center.abc340e703648ea0.svg') no-repeat center center;
  position: absolute;
  top: 0;
  left: 0;
  background-size: contain;
}
.bg-container .bg-rice-paper {
  background: url('2048_rice-paper-6.802831c259f141f5.png');
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  mix-blend-mode: multiply;
}
.bg-container .bg-dark-blue {
  background: url('bg_blue_blur_dark.72ca532f81638e8a.png');
  opacity: 0.7;
  mix-blend-mode: normal;
  position: absolute;
  top: 0;
  left: 0;
}

.pop-info {
  position: absolute;
  background: #f5db6c;
  background-image: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 1rem 1rem 1rem 1rem;
  bottom: 5rem;
  right: 1rem;
  width: 11rem;
  height: 6rem;
  z-index: 10;
}

.overview {
  position: absolute;
  bottom: 4rem;
  left: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 10;
}
.overview .check-here {
  position: absolute;
  bottom: 6rem;
  left: -5rem;
  padding: 1rem;
}
.overview .check-here .text {
  color: white;
  width: 10.708rem;
  font-size: 0.833rem;
  line-height: 1rem;
  text-align: center;
  position: absolute;
  right: -16.2rem;
  top: 0.5rem;
}
.overview .check-here .white-arrow .white-arrow-icon {
  position: absolute;
  left: 6rem;
  width: 2rem;
  height: 3.333rem;
  transform: rotate(60deg);
  --animate-duration: 1s;
}
.overview .oval {
  position: absolute;
  bottom: -1rem;
  left: -0.65rem;
  z-index: 15;
  cursor: pointer;
}
.overview .oval img {
  width: 4rem;
  height: 4rem;
}
.overview .btn-container {
  position: relative;
  margin-right: 0.563rem;
}
.overview .btn-container .btn-icon {
  position: absolute;
  font-size: 1.265rem;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.overview .btn-container ion-img.btn-img::part(image) {
  width: 2.667rem;
  height: 2.667rem;
  cursor: pointer;
}
.overview .btn-container .back {
  top: 0.633rem;
  left: 0.733rem;
}
.overview .btn-container:hover {
  opacity: 0.8;
}
.overview .text {
  font-size: 1rem;
  color: white;
}

.position-description-modal {
  position: absolute;
  min-height: 8.333rem;
  min-width: 20.667rem;
  z-index: 10;
  bottom: 2rem;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
  background: #f5db6c;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  border: 0.1rem solid #d1af1f;
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 1rem;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
}
.position-description-modal .text {
  color: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1rem;
  text-align: center;
  margin-top: 1rem;
}
.position-description-modal .close-button {
  border: 0.083rem solid var(--color-primary-blue);
  border-radius: 1rem;
  font-size: 0.667rem;
  height: 2.1rem;
  width: 8rem;
  color: var(--color-primary-blue);
  text-align: center;
  background: #f5db6c;
}
.position-description-modal .close-button .close-text {
  font-size: 1rem;
  line-height: 1rem;
  text-align: center;
  color: var(--color-primary-blue);
}

.euWebLink {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.euWebLink .link {
  border: 0.083rem solid var(--color-primary-blue);
  border-radius: 1rem;
  font-size: 0.833rem;
  height: 2.5rem;
  min-width: 8rem;
  color: var(--color-primary-blue);
  text-align: center;
  background: #f5db6c;
  text-decoration-line: none;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}
.euWebLink .link:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/game/negotiation_phase/negotiation-phase.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,8JAAA;EAKA,yCAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gDAAA;EACA,WAAA;AAHF;;AAMA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yFAAA;AAHF;;AAOA;EACE,gBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,SAAA;AAJF;;AAOA;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,2CAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gDAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,2BAAA;EACA,6BAAA;AAJF;;AAOA;EACE,6BAAA;EACA,+BAAA;AAJF;;AAOA;EACE,aAAA;EACA,kBAAA;EACA,2CAAA;EACA,WAAA;AAJF;AAME;EACE,aAAA;EACA,iFAAA;EAEA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;AALJ;AAQE;EACE,yDAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;AANJ;AASE;EACE,yDAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,mBAAA;EACA,kGAAA;EAKA,yCAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAZF;;AAeA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAZF;AAcE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAZJ;AAcI;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAZN;AAiBM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;AAfR;AAqBE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAnBJ;AAoBI;EACE,WAAA;EACA,YAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,sBAAA;AApBJ;AAsBI;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AApBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AArBN;AAwBI;EACE,aAAA;EACA,cAAA;AAtBN;AAyBI;EACE,YAAA;AAvBN;AA2BE;EACE,eAAA;EACA,YAAA;AAzBJ;;AA6BA;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,oGAAA;EAKA,4BAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;AA9BF;AAgCE;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AA/BJ;AAiCI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AA/BN;;AAoCA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAjCF;AAmCE;EACE,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAjCJ;AAmCI;EACE,YAAA;AAjCN","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent;\n  --overflow: hidden;\n}\n\n.w-h-100 {\n  width: 100%;\n  height: 100vh;\n}\n\n.box-container {\n  position: absolute;\n  top: 10px;\n  left: 1px;\n  height: 100vh;\n  width: 100%;\n}\n\n.eu-council-game-container {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\n\n.container {\n  position: absolute;\n  top: 0;\n}\n\n.custom-container {\n  position: relative;\n  top: 0;\n  height: 100%;\n  z-index: -2;\n}\n\n.modal-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: #003399b0;\n  z-index: 14;\n}\n\n.reveal {\n  position: absolute;\n  bottom: 4rem;\n  right: 1rem;\n  background: #f5db6c;\n  background-image: linear-gradient(\n    0deg,\n    rgba(var(--ion-color-avatar-choose-contrast-rgb), 0) 0%,\n    rgba(var(--ion-color-avatar-choose-contrast-rgb), 0.48) 100%\n  );\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  border-radius: 1rem;\n  min-width: 10rem;\n  height: 2rem;\n  border: 0.083rem solid var(--color-primary-blue);\n  z-index: 10;\n}\n\n.text {\n  font-size: 0.667rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  line-height: 1rem;\n  padding-inline: 0.5rem;\n}\n\n.text-dismiss {\n  font-size: 0.667rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  line-height: 1rem;\n}\n\n.text2 {\n  margin-top: 0.5rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  font-size: 0.833rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.box2 {\n  position: relative;\n  width: 25rem;\n  margin: 2.083rem auto;\n  padding: 0.833rem;\n  text-align: center;\n  border-radius: 0.458rem;\n  background: var(--color-white);\n  box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0px 1px,\n    rgb(209, 213, 219) 0px 0px 0px 1px inset;\n}\n\n.btn-group {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.topic-box {\n  top: 6rem;\n}\n\n.text-title {\n  color: var(--color-primary-blue);\n  letter-spacing: 0;\n  line-height: 1.333rem;\n  text-align: center;\n  font-size: 1.167rem;\n}\n\n.btn-group .button1 {\n  background-color: var(--color-primary-blue);\n  border: none;\n  color: white;\n  padding: 0.7rem 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.btn-group .button2 {\n  border: 0.118rem solid var(--color-primary-blue);\n  border-radius: 1.33rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  padding: 0.6rem 1.5rem;\n  margin-left: 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.button {\n  border: 0.083rem solid var(--color-primary-blue);\n  border-radius: 1rem;\n  font-size: 0.667rem;\n  height: 2.1rem;\n  width: 8rem;\n  color: var(--color-primary-blue);\n  text-align: center;\n  background: #f5db6c;\n  margin-top: 0.5rem;\n  margin-left: 1.5rem;\n}\n\n.button-end {\n  border-end-end-radius: 3rem;\n  border-start-end-radius: 3rem;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n\n.bg-container {\n  height: 100vh;\n  position: relative;\n  background-color: var(--color-primary-blue);\n  z-index: -1;\n\n  .bg-lantern {\n    display: flex;\n    background: url(../../../assets/d1/lantern-bg-center.svg) no-repeat center\n      center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-size: contain;\n  }\n\n  .bg-rice-paper {\n    background: url(../../../assets/d1/2048_rice-paper-6.png);\n    opacity: 0.7;\n    position: absolute;\n    top: 0;\n    left: 0;\n    mix-blend-mode: multiply;\n  }\n\n  .bg-dark-blue {\n    background: url(../../../assets/d1/bg_blue_blur_dark.png);\n    opacity: 0.7;\n    mix-blend-mode: normal;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n.pop-info {\n  position: absolute;\n  background: #f5db6c;\n  background-image: linear-gradient(\n    0deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.48) 100%\n  );\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  border-radius: 1rem 1rem 1rem 1rem;\n  bottom: 5rem;\n  right: 1rem;\n  width: 11rem;\n  height: 6rem;\n  z-index: 10;\n}\n\n.overview {\n  position: absolute;\n  bottom: 4rem;\n  left: 1rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  z-index: 10;\n\n  .check-here {\n    position: absolute;\n    bottom: 6rem;\n    left: -5rem;\n    padding: 1rem;\n\n    .text {\n      color: white;\n      width: 10.708rem;\n      font-size: 0.833rem;\n      line-height: 1rem;\n      text-align: center;\n      position: absolute;\n      right: -16.2rem;\n      top: 0.5rem;\n    }\n\n    .white-arrow {\n\n      .white-arrow-icon {\n        position: absolute;\n        left: 6rem;\n        width: 2rem;\n        height: 3.333rem;\n        transform: rotate(60deg);\n        --animate-duration: 1s;\n      }\n\n    }\n  }\n\n  .oval {\n    position: absolute;\n    bottom: -1rem;\n    left: -0.65rem;\n    z-index: 15;\n    cursor: pointer;\n    img {\n      width: 4rem;\n      height: 4rem;\n    }\n  }\n\n  .btn-container {\n    position: relative;\n    margin-right: 0.563rem;\n\n    .btn-icon {\n      position: absolute;\n      font-size: 1.265rem;\n      color: var(--color-primary-blue);\n      cursor: pointer;\n    }\n\n    ion-img.btn-img::part(image) {\n      width: 2.667rem;\n      height: 2.667rem;\n      cursor: pointer;\n    }\n\n    .back {\n      top: 0.633rem;\n      left: 0.733rem;\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .text {\n    font-size: 1rem;\n    color: white;\n  }\n}\n\n.position-description-modal {\n  position: absolute;\n  min-height: 8.333rem;\n  min-width: 20.667rem;\n  z-index: 10;\n  bottom: 2rem;\n  left: 50%;\n  transform: translate(-50%, 0);\n  cursor: pointer;\n  background: #f5db6c;\n  background-image: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.48) 100%\n  );\n  border: 0.1rem solid #d1af1f;\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  border-radius: 1rem;\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n  align-items: center;\n\n  .text {\n    color: var(--color-primary-blue);\n    font-size: 1rem;\n    line-height: 1rem;\n    text-align: center;\n    margin-top: 1rem;\n  }\n\n  .close-button {\n    border: 0.083rem solid var(--color-primary-blue);\n    border-radius: 1rem;\n    font-size: 0.667rem;\n    height: 2.1rem;\n    width: 8rem;\n    color: var(--color-primary-blue);\n    text-align: center;\n    background: #f5db6c;\n\n    .close-text {\n      font-size: 1rem;\n      line-height: 1rem;\n      text-align: center;\n      color: var(--color-primary-blue);\n    }\n  }\n}\n\n.euWebLink {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  .link {\n    border: 0.083rem solid var(--color-primary-blue);\n    border-radius: 1rem;\n    font-size: 0.833rem;\n    height: 2.5rem;\n    min-width: 8rem;\n    color: var(--color-primary-blue);\n    text-align: center;\n    background: #f5db6c;\n    text-decoration-line: none;\n    padding: 0.5rem 1rem;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
